import C from "./constants";
import Pages from "./pages";
import fetch from "isomorphic-fetch";
import axios from "axios"
import FormData from "form-data";
import ReactOnRails from "react-on-rails";
import { buildProfileForm, updateForm, blankOrValue } from "./utilities";

const handleErrors = response => {
  const ok = response.ok || response.status === 200

  if (!ok) {
    var error = new Error(response.statusText || response.status);
    error.response = response;
    throw error;
  }

  return response;
};

const userWithSubmittedPhoneMobile = (user, phoneMobile) => {
  if (!phoneMobile || user.host?.phone_mobile) return user;

  console.warn('[host-signup] Registration response did not include host.phone_mobile; using submitted phone for verification handoff.');

  return {
    ...user,
    host: {
      ...user.host,
      phone_mobile: phoneMobile
    }
  };
};

export const updateSchools = payload => dispatch => {
  const formUrl = "/hosts/update_schools.json"

  const submit = async() => {
    return await fetch(formUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
  }
  submit()
  .then(handleErrors)
  .then(response => response.json())
  .then(user => {
    dispatch(setUser(user));
  })
};

export const guestPackagesSubmit = payload => dispatch => {
  const formUrl = `/hosts/update_products.json`;
  const form = new FormData();
  form.append("authenticity_token", ReactOnRails.authenticityToken());
  form.append("host_id", payload.host_id)
  form.append("service_level", payload.serviceLevel)

  const updateAvailableProducts = async() => {
    return await fetch(formUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      body: form
    })
  };

  updateAvailableProducts()
  .then(handleErrors)
  .then(response => response.json())
  .then(data => {
    dispatch(setProfileElements(data))
    dispatch(setNextPage(true))
  })
};
// Photos
export const invalidatePhotos = (content) =>
  ({
    type: C.INVALIDATE_PHOTOS,
    payload: content
  });

export const requestPhotos = (content) =>
  ({
    type: C.REQUEST_PHOTOS,
    payload: content
  });

export const receivePhotos = (json) => {
  return {
    type: C.RECEIVE_PHOTOS,
    photos: json,
    receivedAt: Date.now()
  };
};

export const setUploadProgress = progress => ({
  type: C.SET_UPLOAD_PROGRESS,
  payload: { progress }
})

export const setUploadStatus = status => ({
  type: C.SET_UPLOAD_STATUS,
  payload: { status }
})

export const resetUpload = () => ({ type: C.RESET_UPLOAD })

export const fetchPhotos = (state) => dispatch => {
    let document_id = state.user.host.id;
    let document_type = "Lobby::Host";
    let url = `/host_photos.json?host_id=${document_id}`;

    dispatch(requestPhotos(true));

    return fetch(
        url,
      {
        credentials: "same-origin",
        headers: {
          "Accept": "application/json, text/plain, */*",
          "Content-Type": "application/json"
          }
      })
      .then(response => response.json())
      .then(json => {
        dispatch(receivePhotos(json));
      }
    );
  };

export const photoFormSubmit = payload => dispatch => {
  const formUrl = payload.form.photo.id ? `/host_photos/${payload.form.photo.id}.js` : "/host_photos.js";
  const formMethod = payload.method;

  let form = new FormData();
  form.append("authenticity_token", payload.form.authenticity_token);
  form.append("host_id", payload.form.host_id);
  form.append("resident_id", blankOrValue(payload.form.resident_id));
  form.append("room_id", blankOrValue(payload.form.room_id));
  form.append("photo[name]", blankOrValue(payload.form.photo.name));
  form.append("photo[description]", blankOrValue(payload.form.photo.description));

  if(payload.form.room_id){
    form.append("photo[kind]", "student_room");
  } else {
    form.append("photo[kind]", payload.form.photo.kind);
  }

  if(!payload.form.photo.id){
    form.append("photo[image]", payload.form.photo.file);
  }

  dispatch(setUploadStatus("Uploading"))

  const submit = async () => (
    await axios({
      url: formUrl,
      method: formMethod,
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

        dispatch(setUploadProgress(percentCompleted))
        if (percentCompleted > 99) dispatch(setUploadStatus("Processing"))
      },
      data: form
    })
  )

  submit()
  .then(handleErrors)
  .then(response => {
    let subject;
    if (payload.form.resident_id){subject = "resident"};
    if (payload.form.room_id){subject = "room"};


    dispatch(resetUpload())

    switch (subject) {
      case "room":
        dispatch(invalidateRooms());
        dispatch(invalidatePhotos());
        return dispatch(fetchRoomsIfNeeded());
      case "resident":
        dispatch(invalidateResidents());
        return dispatch(fetchResidentsIfNeeded());
      default:
        dispatch(invalidatePhotos());
        return dispatch(fetchPhotosIfNeeded());
    }
  })
};

export const certificateFormSubmit = payload => dispatch => {
  let form = new FormData();

  form.append("authenticity_token", payload.form.authenticity_token);
  form.append("host_id", payload.form.host_id);
  form.append("resident_id", blankOrValue(payload.form.resident_id));
  form.append("attachment[name]", payload.form.attachment.name);
  form.append("attachment[kind]", payload.form.attachment.kind);
  form.append("attachment[file]", payload.form.attachment.file);

  dispatch(setUploadStatus("Uploading"))

  const submit = async () => (
    await axios({
      url: `/residents/${payload.form.resident_id}/upload_certificate.js`,
      method: "POST",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

        dispatch(setUploadProgress(percentCompleted))
        if (percentCompleted > 99) dispatch(setUploadStatus("Processing"))
      },
      data: form
    })
  )

  submit()
  .then(handleErrors)
  .then(() => {
    dispatch(resetUpload())

    dispatch(invalidateResidents());
    dispatch(fetchResidentsIfNeeded());
  })
};

export const policeVettingFormSubmit = payload => dispatch => {
  let form = new FormData();

  form.append("authenticity_token", payload.form.authenticity_token);
  form.append("resident_id", blankOrValue(payload.form.resident_id));

  for (var i = 0; i < payload.form.attachments.length; i++) {
    let attachmentData = new FormData()

    form.append('id', payload.form.resident_id)
    form.append('host_id', payload.form.host_id)
    form.append('attachments[][name]', payload.form.attachments[i].name)
    form.append('attachments[][kind]', payload.form.attachments[i].kind)
    form.append('attachments[][file]', payload.form.attachments[i].file)
  }

  for (var pair of form.entries()) {
      console.log(pair[0]+ ', ' + pair[1]);
  }

  dispatch(setUploadStatus("Uploading"))

  const submit = async () => (
    await axios({
      url: `/police_vettings/upload_documents`,
      method: "POST",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

        dispatch(setUploadProgress(percentCompleted))
        if (percentCompleted > 99) dispatch(setUploadStatus("Processing"))
      },
      data: form
    })
  )

  submit()
  .then(handleErrors)
  .then(() => {
    dispatch(resetUpload())

    dispatch(invalidateResidents());
    dispatch(fetchResidentsIfNeeded());
  })
}

export const shouldFetchPhotos = (state) => {
  let photos = state.photos;
  if (!photos) {
    return true;
  } else if (photos.isFetching) {
    return false;
  } else {
    return photos.didInvalidate;
  }
};

export const fetchPhotosIfNeeded = (subject) => {
  return (dispatch, getState) => {

    if (shouldFetchPhotos(getState())) {
      return dispatch(fetchPhotos(getState()));
    }
  };
};
// Residents
export const invalidateResidents = (content) =>
  ({
    type: C.INVALIDATE_RESIDENTS,
    payload: content
  });

export const requestResidents = (content) =>
  ({
    type: C.REQUEST_RESIDENTS,
    payload: content
  });

export const receiveResidents = (json) => {
  return {
    type: C.RECEIVE_RESIDENTS,
    residents: json,
    receivedAt: Date.now()
  };
};

export const fetchResidents = () => dispatch => {
    dispatch(requestResidents(true));
    const submit = async() => {
      return await fetch(
          "/residents.json",
        {
          credentials: "same-origin",
          headers: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": "application/json"
            }
        })
    }
    submit()
    .then(response => response.json())
    .then(json => {
      dispatch(receiveResidents(json));
    });
  };

export const residentFormSubmit = payload => dispatch => {
  const formUrl = payload.host_resident.id ? `/residents/${payload.host_resident.id}.json` : "/residents.json";
  const formMethod = payload.host_resident.id ? "PUT" : "POST";

  fetch(formUrl, {
      method: formMethod,
      credentials: "same-origin",
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify( payload )
  })
  .then(handleErrors)
  .then(response => response.json())
  .then(resident => {
    dispatch(fetchResidents());
  })
};

export const shouldFetchResidents = (state) => {
  let residents = state.residents;
  if (!residents) {
    return true;
  } else if (residents.isFetching) {
    return false;
  } else {
    return residents.didInvalidate;
  }
};

export const fetchResidentsIfNeeded = () => {
  return (dispatch, getState) => {
    if (shouldFetchResidents(getState())) {
      return dispatch(fetchResidents());
    }
  };
};

// Host
export const invalidateHost = (content) => ({
    type: C.INVALIDATE_HOST,
    payload: content
  });

export const requestHost = (content) => ({
    type: C.REQUEST_HOST,
    payload: content
  });

export const receiveHost = (json) => {
  return {
    type: C.RECEIVE_HOST,
    host: json,
    receivedAt: Date.now()
  }
}

export const shouldFetchHost = (state) => {
  let host = state.host
  if (!host) {
    return true
  } else if (host.isFetching) {
    return false
  } else {
    return host.didInvalidate
  }
}

export const fetchHostIfNeeded = () => {
  return (dispatch, getState) => {
    if (shouldFetchHost(getState())) {
      return dispatch(fetchHost())
    }
  }
}

export const fetchHost = () => dispatch => {
    dispatch(requestHost(true))
    return fetch("/hosts.json", {
        credentials: "same-origin",
        headers: {
          "Accept": "application/json, text/plain, */*",
          "Content-Type": "application/json"
          }
      })
      .then(response => response.json())
      .then(json => {
        dispatch(receiveHost(json))
      }
    )
  }

export const completeWizard = payload => dispatch => {
  const url = "/hosts/complete_wizard";
  let form = new FormData();
  form.append("authenticity_token", payload.authenticity_token);
  const submit = async() => {
    return await fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      body: form
    })
  }
  submit()
  .then(response => response.json())
  .then(response => {
    dispatch(
      setCompleted(true)
    );
    window.location = payload.redirect_url;
  })
}

export const withdrawSubmit = payload => dispatch => {
  const url = "/hosts/withdraw.json";
  let form = new FormData();
  form.append("authenticity_token", payload.csrf_token);
  fetch(url, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      body: form
  })
  .then(response => {
    dispatch(
      setWithdrawn(true)
    );
  });
};

export const paymentsSubmit = payload => dispatch => {
  fetch("/hosts/update_banking.json", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify( payload )
  })
  .then(handleErrors)
  .then(response => response.json())
  .then(user => {
    dispatch(setUser(user));
  })
  .then(dispatch(setNextPage(true)))
}

export const referralSubmit = payload => dispatch => {
  const submit = async() => {
    return await fetch("/hosts/update_referral.json", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json, text/plain, */*",
          "Content-Type": "application/json"
        },
        body: JSON.stringify( payload )
    })
  }
  submit()
  .then(handleErrors)
  .then(response => response.json())
  .then(json => {
    dispatch(setUser(json))
  })
  .then(dispatch(setNextPage(true)))
}

// Rooms
export const invalidateRooms = (content) =>
  ({
    type: C.INVALIDATE_ROOMS,
    payload: content
  });

export const requestRooms = (content) =>
  ({
    type: C.REQUEST_ROOMS,
    payload: content
  });

export const receiveRooms = (json) => {
  return {
    type: C.RECEIVE_ROOMS,
    rooms: json,
    receivedAt: Date.now()
  };
};

export const fetchRooms = () => dispatch => {
    dispatch(requestRooms(true))

    const submit = async() => {
      return await fetch("/host_rooms.json",
        {
          credentials: "same-origin",
          headers: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": "application/json"
            }
        }
      )
    }
    submit()
    .then(response => response.json())
    .then(json => {
      dispatch(receiveRooms(json));
    });
  };

export const roomFormSubmit = payload => dispatch => {
  const formUrl = payload.room.id ? `/host_rooms/${payload.room.id}.json` : "/host_rooms.json";
  const formMethod = payload.room.id ? "PUT" : "POST";

  fetch(formUrl, {
      method: formMethod,
      credentials: "same-origin",
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify( payload )
  })
  .then(handleErrors)
  .then(response => response.json())
  .then(room => {
    dispatch(fetchRooms());
  })
};

export const shouldFetchRooms = (state) => {
  let rooms = state.rooms;
  if (!rooms) {
    return true;
  } else if (rooms.isFetching) {
    return false;
  } else {
    return rooms.didInvalidate;
  }
};

export const fetchRoomsIfNeeded = () => {
  return (dispatch, getState) => {
    if (shouldFetchRooms(getState())) {
      return dispatch(fetchRooms());
    }
  };
};

// Others
export const setContent = (content) =>
  ({
    type: C.SET_CONTENT,
    payload: content
  });

export const setTerms = (terms) =>
  ({
    type: C.SET_TERMS,
    payload: terms
  });

export const setWithdrawn = (withdrawn) =>
  ({
    type: C.SET_WITHDRAWN,
    payload: withdrawn
  });

export const setCompleted = (completed) =>
  ({
    type: C.SET_COMPLETED,
    payload: completed
  });

export const setPage = (page) =>
  ({
    type: C.SET_PAGE,
    payload: page
  });

export const setEnvironment = (environment) =>
  ({
    type: C.SET_ENVIRONMENT,
    payload: environment
  });

export const setPages = (pages) =>
  ({
    type: C.SET_PAGES,
    payload: pages
  });

export const setNextPage = (next_page) =>
  ({
    type: C.SET_NEXT_PAGE,
    payload: next_page
  });


export const setPreviousPage = (previous_page) =>
  ({
    type: C.SET_PREVIOUS_PAGE,
    payload: previous_page
  });

export const setProfileElements = (profile_elements) =>
  ({
    type: C.SET_PROFILE_ELEMENTS,
    payload: profile_elements
  });

export const setRequiredFields = (required_fields) =>
  ({
    type: C.SET_REQUIRED_FIELDS,
    payload: required_fields
  });

export const setResidentVaccinationOptions = (resident_vaccination_options) =>
  ({
    type: C.SET_RESIDENT_VACCINATION_OPTIONS,
    payload: resident_vaccination_options
  });

export const setLocalProfileElements = (local_profile_elements) =>
  ({
    type: C.SET_LOCAL_PROFILE_ELEMENTS,
    payload: local_profile_elements
  });

export const setResidents = (residents) =>
  ({
    type: C.SET_RESIDENTS,
    payload: residents
  });

export const setUser = (user) =>
  ({
    type: C.SET_USER,
    payload: user
  });

export const setRegistered = (registered) =>
  ({
    type: C.SET_REGISTERED,
    payload: registered
  });

export const setHolding = (holding) =>
  ({
    type: C.SET_HOLDING,
    payload: holding
  });

export const setAddress = (address) =>
  ({
    type: C.SET_ADDRESS,
    payload: address
  });

export const setProceedFromHolding = (proceed_from_holding) =>
  ({
    type: C.SET_PROCEED_FROM_HOLDING,
    payload: proceed_from_holding
  });

export const setAffiliate = (affiliate) =>
  ({
    type: C.SET_AFFILIATE,
    payload: affiliate
  });

export const setReferralProgram = (referral_program) =>
  ({
    type: C.SET_REFERRAL_PROGRAM,
    payload: referral_program
  });

export const setLanguageOptions = (language_options) =>
  ({
    type: C.SET_LANGUAGE_OPTIONS,
    payload: language_options
  });

export const setEthnicityOptions = (ethnicity_options) =>
  ({
    type: C.SET_ETHNICITY_OPTIONS,
    payload: ethnicity_options
  });

export const setTerritory = (territory) =>
  ({
    type: C.SET_TERRITORY,
    payload: territory
  });

export const setMarket = (market) =>
  ({
    type: C.SET_MARKET,
    payload: market
  });

export const setActiveProfileElements = (active_profile_elements) =>
  ({
    type: C.SET_ACTIVE_PROFILE_ELEMENTS,
    payload: active_profile_elements
  });

export const acceptTerms = payload => dispatch => {
  dispatch(
    setTerms(true)
  );
};

export const backToAddress = () => dispatch => {
  dispatch(setAddress(null))
  dispatch(setPage(Pages.ADDRESS_PAGE))
}

export const registerUser = payload => (dispatch, getState) => {
  const formUrl = "/hosts.js";

  let form = new FormData();

  form.append("authenticity_token", payload.csrf_token);
  form.append("affiliate", getState().affiliate || payload.affiliate || '');
  form.append("firebase_id", blankOrValue(payload.firebase_id));
  form.append("user[given_names]", payload.givenNames);
  form.append("user[family_name]", payload.familyName);
  form.append("user[host_attributes][phone_mobile]", payload.phone);
  form.append("user[email]", payload.email);
  form.append("user[password]", payload.password || '');
  form.append("user[dob]", payload.dob);
  form.append("user[gender]", blankOrValue(payload.gender));
  form.append("user[host_attributes][referred_from]", blankOrValue(payload.referredFrom));
  form.append("user[host_attributes][territory_id]", getState().territory.id);
  form.append("address[unit_no]", blankOrValue(payload.address.unit_no));
  form.append("address[street_no]", blankOrValue(payload.address.street_no));
  form.append("address[street_name]", blankOrValue(payload.address.street_name));
  form.append("user[host_attributes][address_city]", blankOrValue(payload.address.city));
  form.append("user[host_attributes][address_state]", blankOrValue(payload.address.state));
  form.append("user[host_attributes][address_post_code]", blankOrValue(payload.address.post_code));
  form.append("user[host_attributes][country_code]", blankOrValue(payload.address.country_code));
  form.append("user[host_attributes][coordinates]", blankOrValue(payload.address.coordinates));
  form.append("user[host_attributes][sign_up_method]", payload.sign_up_method);

  const submit = async() => {
    return await fetch(formUrl, {
      method: "post",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      body: form
    })
  }
  submit()
  .then(handleErrors)
  .then(response => response.json())
  .then(user => {
    const registeredUser = userWithSubmittedPhoneMobile(user, payload.phone);

    dispatch(
      setUser(registeredUser)
    );
    if (registeredUser.host.host_referral_program_active == false){
      let new_pages = getState().pages.filter(s => s !== "referral");
      dispatch(
        setPages(new_pages)
      )
    };
    if (registeredUser.host.assigned_office == false){
      dispatch(
        setHolding(true)
      );
    };
    let marital_status = blankOrValue(payload.maritalStatus)
    if (marital_status){
      dispatch(hostProfileSubmit({
        lifestyle: {
          marital_status: marital_status
        }
      }, false));
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'hms_signup_success',
      userType: 'host'
    });

    dispatch(
      setRegistered(true)
    );
  })
};

export const authFirebaseUser = payload => dispatch => {
  const token = payload.token
  const authenticatedUser = async () => {
    return (
      await fetch('/hosts/create_authenticated_user', {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json, text/plain, */*",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ token })
      })
    )
  }
  authenticatedUser()
  .then(handleErrors)
  .then(response => response.json())
  .then(data => {
    const user = {
      authId: data.authenticated_user_id,
      email: payload.email,
      password: payload.password
    }
    dispatch(setUser(user))
  })
};

export const skipSubmit = payload => dispatch => {
  dispatch(
    setNextPage(true)
  );
};

export const goBack = payload => dispatch => {
  dispatch(
    setPreviousPage(true)
  );
};

// new constants
export const conclusionSubmit = payload => dispatch => {
  dispatch(
    setNextPage(true)
  );
};
export const contactSubmit = payload => dispatch => {
  dispatch(
    setNextPage(true)
  );
};

export const photoSubmit = payload => dispatch => {
  const formUrl = "/hosts/submit_photos";
  const authenticityToken = ReactOnRails.authenticityToken();

  let form = new FormData();
  form.append("authenticity_token", authenticityToken);

  fetch(formUrl, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      body: form
  })

  dispatch(
    setNextPage(true)
  );
};

export const roomsSubmit = payload => dispatch => {
  const formUrl = "/host_rooms/submit";
  const authenticityToken = ReactOnRails.authenticityToken();

  let form = new FormData();
  form.append("authenticity_token", authenticityToken);

  fetch(formUrl, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      body: form
  })
};

export const residentsSubmit = payload => dispatch => {
  const formUrl = "/residents/submit";
  const authenticityToken = ReactOnRails.authenticityToken();

  let form = new FormData();
  form.append("authenticity_token", authenticityToken);

  fetch(formUrl, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      body: form
  })
  dispatch(
    setNextPage(true)
  );
};
export const profileSubmit = payload => dispatch => {
  dispatch(
    setNextPage(true)
  );
};
export const intervalSubmit = payload => dispatch => {
  dispatch(
    setNextPage(true)
  );
};
export const dietSubmit = payload => dispatch => {
  dispatch(
    setNextPage(true)
  );
};
export const guestPreferencesSubmit = payload => dispatch => {
  dispatch(
    setNextPage(true)
  );
};
export const culturalBackgroundSubmit = payload => dispatch => {
  dispatch(
    setNextPage(true)
  );
};
export const hostProfileSubmit = (payload, set_page = true) => (dispatch, getState) => new Promise((resolve) => {
  const formUrl = "/profile_element_entries.json";
  const schema = getState().localProfileElements.schema;
  const profileElements = getState().profileElements;
  const authenticityToken = ReactOnRails.authenticityToken();
  const hostId = getState().user.host.id;

  let form = {
    authenticity_token: authenticityToken,
    admin: false,
    doc_id: hostId,
    doc_type: "Lobby::Host",
    profile_element_entry: buildProfileForm(schema, profileElements)
  };

  form.profile_element_entry = updateForm(form.profile_element_entry, schema, payload);

  fetch(formUrl, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": "application/json"
    },
    body: JSON.stringify( form )
  })
  .then(response => response.json())
  .then(data => {
    dispatch(setProfileElements(data))
    if(set_page){ dispatch(setNextPage(true)) }
  })
  .then(() => resolve())
})

export const verifyHostPhoneNumber = (newPhoneMobile, verificationId, code) => (dispatch, getState) => new Promise((resolve) => {
  const formUrl = "/phone_numbers/confirm";
  const currentUser = getState().user;
  const phoneMobile = newPhoneMobile || currentUser.host.phone_mobile;
  const hostId = currentUser.host.id;

  let form = {
    phone: phoneMobile,
    verification_id: verificationId,
    code: code
  };

  const csrfToken = document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').content : '';

  fetch(
    formUrl,
    {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify(form)
    }
  )
  .then(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'phone_verified',
      userType: "host"
    });

    if (newPhoneMobile && newPhoneMobile !== currentUser.host.phone_mobile) {
      dispatch(setUser({
        ...currentUser,
        host: {
          ...currentUser.host,
          phone_mobile: newPhoneMobile
        }
      }));
    }

    dispatch(setPage(Pages.INFO_PAGE))
    resolve();
  })
})

export const updateHostPhoneNumber = (phoneMobile) => (dispatch, getState) => new Promise((resolve, reject) => {
  const formUrl = "/phone_numbers";
  const currentUser = getState().user;
  const hostId = currentUser.host.id;

  let form = {
    phone: phoneMobile,
    id: hostId
  };

  fetch(
    formUrl,
    {
      method: "PUT",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      },
      body: JSON.stringify(form)
    }
  )
  .then(response => {
    if (!response.ok) {
      return response.text().then(text => {
        try {
          const err = JSON.parse(text);
          const errorMsg = err.errors ? err.errors.join(", ") : "Something went wrong.";
          throw new Error(errorMsg);
        } catch (e) {
          throw new Error("Something went wrong.");
        }
      });
    }
    return response.json();
  })
  .then(data => {
    dispatch(setUser({
      ...currentUser,
      host: { ...currentUser.host, phone_mobile: phoneMobile }
    }))
    resolve();
  })
  .catch(err => {
    reject(err);
  })
})

export const holdingSubmit = payload => dispatch => {
  dispatch(
    setProceedFromHolding(true)
  );
};

export const cancelSubmit = payload => dispatch => {
};

export const updateSignupPage = page => () => {
  if (page && page != "" && page != "register"){
   const url = `/hosts/signup/update_page`;
   let form = new FormData();
   form.append("page", page);
   fetch(url, {
       method: "PATCH",
       credentials: "same-origin",
       headers: {"X-Requested-With": "XMLHttpRequest"},
       body: form
   });
  }
};

export const submitPassword = payload => (dispatch) => {
  let form = new FormData();
  form.append("authenticity_token", payload.authenticity_token);
  form.append("password", payload.password);
  const submit = async() => {
    return await fetch("/hosts/signup/set_password", {
      method: "PATCH",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      body: form
    })
  }
  submit()
  .then(handleErrors)
  .then(response => response.json())
  .then(user => {
    dispatch(
      setUser(user)
    );
  })
}

export const updateAllVaccinationStatus = payload => (dispatch) => {
  let form = new FormData();
  const authenticityToken = ReactOnRails.authenticityToken();

  form.append("authenticity_token", authenticityToken);
  form.append("vaccination[state]", payload);

  const submit = async() => {
    return await fetch("/residents/update_all_vaccination_status", {
      method: "PATCH",
      credentials: "same-origin",
      headers: {"X-Requested-With": "XMLHttpRequest"},
      body: form
    })
  }
  submit()
  .then(handleErrors)
  .then(response => response.json())
  .then(() => {
    dispatch(fetchResidents());
  })
}
